<template>
  <div id="login" style="min-height: 65.4vh">
    <div class="bac">
      <div class="topHead">
        <div class="regist0">用户注册</div>
        <div class="register">
          <div class="rleft">已有账号？</div>
          <div class="rright">
            <router-link class="rright" to="/login">立即登录</router-link>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title">会员注册</div>
        <div class="item">
          <div class="left"><span style="color: #ff0000">*</span>用户名：</div>
          <input
            class="inputBac"
            placeholder="请输入账号"
            v-model="accountNumber"
            :maxlength="accountMaxLength"
            @blur="accountBlur"
          />
          <div class="inputSub">{{ accountP }}</div>
        </div>

        <div class="item">
          <div class="left"><span style="color: #ff0000">*</span>密码：</div>
          <input
            type="password"
            class="inputBac"
            placeholder="请输入密码"
            v-model="password"
            @blur="passwordBlur"
          />
          <div class="inputSub">
            密码为6-15位,数字/字母/标点符号3种至少包含2种！
          </div>
        </div>

        <div class="item">
          <div class="left">
            <span style="color: #ff0000">*</span>确认密码：
          </div>
          <input
            type="password"
            class="inputBac"
            placeholder="请输入确认密码"
            v-model="confirmPassword"
            @blur="confirmPasswordBlur"
          />
          <div class="inputSub">必须与登录密码一致</div>
        </div>

        <div class="item" v-if="regFlag && regFlag.phone">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.phone == 2">*</span
            >联系电话：
          </div>
          <input
            class="inputBac"
            v-model="phone"
            :placeholder="
              regFlag.phone == 1 ? '请输入手机号（选填）' : '请输入手机号'
            "
            maxlength="11"
            @blur="phone = toCDB(phone)"
          />
          <div class="inputSub">请输入正确联系电话</div>
        </div>
        <div
          class="item"
          v-show="regFlag && regFlag.smsCode && regFlag.phone == 2"
        >
          <div class="left">
            <span
              style="color: #ff0000"
              v-show="regFlag && regFlag.smsCode && regFlag.phone == 2"
              >*</span
            >短信验证码：
          </div>
          <div>
            <input
              style="width: 170px"
              class="inputBac"
              v-model="smsCode"
              placeholder="请输入短信验证码"
              maxlength="8"
              @blur="smsCode = toCDB(smsCode)"
            />
          </div>
          <!--  行为验证 急眼 -->
          <div>
            <div class="getCode getsmsCode" @click="getSmsCode">
              {{ smsBtnText }}
            </div>
          </div>
        </div>
        <div class="item regCode" v-if="regFlag && regFlag.inviteCode">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.inviteCode == 2">*</span
            >邀请码：
          </div>
          <input
            v-if="sessData"
            type="text"
            class="inputBac"
            :placeholder="
              regFlag.inviteCode == 1 ? '请输入邀请码（选填）' : '请输入邀请码'
            "
            v-model="inviteCode"
            @blur="inviteCodeBlur"
            :disabled="inviteCode ? true : false"
          />
          <input
            v-else
            type="text"
            class="inputBac"
            :placeholder="
              regFlag.inviteCode == 1 ? '请输入邀请码（选填）' : '请输入邀请码'
            "
            v-model="inviteCode"
            @blur="inviteCodeBlur"
          />
        </div>

        <!-- 姓名 -->
        <div class="item regRealName" v-if="regFlag && regFlag.realName">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.realName == 2">*</span
            >姓名：
          </div>

          <input
            type="text"
            class="inputBac"
            :placeholder="
              regFlag.realName == 1 ? '请输入姓名（选填）' : '请输入姓名'
            "
            v-model="realName"
          />
        </div>

        <!-- 性别 -->
        <div class="item regSex" v-if="regFlag && regFlag.sex">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.sex == 2">*</span>性别：
          </div>
          <!-- <div class="btnTextColor">请选择性别：</div> -->
          <div class="maleSex" @click="sex = 1">
            <!-- <img
              class="sexImg"
              :src="sex == 1 ?  require('../../assets/images/regChecked.png') : require('../../assets/images/regUnCheck.png')"
            /> -->
            <span class="btnTextColor">男</span>
          </div>

          <div class="femaleSex" @click="sex = 0" style="margin-left: 0.5rem">
            <!-- <img
              class="sexImg"
              :src="sex == 0 ?  require('../../assets/images/regChecked.png') :   require('../../assets/images/regUnCheck.png')"
            /> -->
            <span class="btnTextColor">女</span>
          </div>
        </div>

        <!--生日 -->
        <div class="item regBirthday" v-if="regFlag && regFlag.birthday">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.birthday == 2">*</span
            >生日：
          </div>
          <!-- <input type="text" class="inputBac" placeholder="请输入生日" v-model="birthday" /> -->
          <el-date-picker
            v-model="birthday"
            type="date"
            :placeholder="
              regFlag.birthday == 1 ? '请输入生日（选填）' : '请输入生日'
            "
          ></el-date-picker>
        </div>

        <!-- 微信 -->
        <div class="item regWechat" v-if="regFlag && regFlag.wechat">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.wechat == 2">*</span
            >微信号：
          </div>
          <input
            type="text"
            class="inputBac"
            maxlength="20"
            :placeholder="
              regFlag.wechat == 1 ? '请输入微信号码（选填）' : '请输入微信号码'
            "
            v-model="wechat"
          />
        </div>

        <!-- qq -->
        <div class="item regQQ" v-if="regFlag && regFlag.qq">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.qq == 2">*</span>QQ号：
          </div>
          <input
            type="text"
            class="inputBac"
            maxlength="15"
            :placeholder="
              regFlag.qq == 1 ? '请输入QQ号码（选填）' : '请输入QQ号码'
            "
            v-model="qq"
          />
        </div>

        <!-- email -->
        <div class="item regEmail" v-if="regFlag && regFlag.email">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.email == 2">*</span
            >邮箱：
          </div>
          <input
            type="text"
            class="inputBac"
            :placeholder="
              regFlag.email == 1 ? '请输入邮箱地址（选填）' : '请输入邮箱地址'
            "
            v-model="email"
          />
        </div>

        <!-- 地址 -->
        <div class="item regAddress" v-if="regFlag && regFlag.address">
          <div class="left">
            <span style="color: #ff0000" v-if="regFlag.address == 2">*</span
            >地址：
          </div>
          <input
            type="text"
            class="inputBac"
            :placeholder="
              regFlag.address == 1 ? '请输入联系地址（选填）' : '请输入联系地址'
            "
            v-model="address"
          />
        </div>

        <div class="item" v-show="type === 0">
          <div class="left"><span style="color: #ff0000">*</span>验证码：</div>
          <input
            class="inputBac"
            placeholder="请输入验证码"
            v-model="captchaCode"
          />
          <div
            :style="
              'background-image:url(' +
              verifyCodeImg +
              ');background-repeat:no-repeat;'
            "
            class="codeimg"
            v-if="verifyCodeImg"
            @click="captchaData"
          ></div>
          <div
            class="verifyCodeImg getCode"
            v-if="!verifyCodeImg"
            @click="captchaData"
          >
            <!-- <img src="../../assets/images/refresh.png" class="refimg" /> -->
            重新获取
          </div>
        </div>

        <!-- 行为校验  树莓 -->
        <div class="item" v-show="type === 2">
          <div
            v-show="type === 2"
            id="captcha"
            class="loginBtn captchaStyle"
            @click="captchaClick"
          >
            {{ captchaText }}
          </div>
          <div>
            <div v-if="errorCode" class="getCode" @click="getDefaultStatus">
              <!-- <img src="../../assets/images/refresh.png" class="refimg" alt /> -->
              重新获取
            </div>
          </div>
        </div>
        <!--  行为验证 急眼 -->
        <div class="item" v-show="type === 1">
          <div class="left"><span style="color: #ff0000">*</span>验证码：</div>
          <!--  行为验证 急眼 -->
          <div v-show="type === 1" id="captcha3" class></div>
          <div>
            <div v-if="errorCode" class="getCode" @click="getDefaultStatus">
              <!-- <img src="../../assets/images/refresh.png" class="refimg" alt /> -->
              重新获取
            </div>
          </div>
        </div>

        <div class="r-bottom1">
          <input
            type="checkbox"
            class="radio"
            v-model="isSelect"
            value="isSelect"
          />
          <div>
            我已阅读并同意
            <span style="color: #1b66c7">《用户服务协议》</span>
          </div>
        </div>

        <div class="bottom" style="margin-bottom: 15px; margin-top: 10px">
          <button class="btn" background-color="#ff000" @click="register()">
            立即注册
          </button>
        </div>
        <div
          style="
            margin-top: 1px;
            margin-left: 110px;
            margin-bottom: 10px;
            color: #333333;
            font-size: 12px;
          "
        >
          温馨提示：带
          <span style="color: #ff0000">*</span>为必填项，其他为选填
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./login.scss";
import store from "../../store/store";
import gt from "../../utils/gt.js";
import "../../utils/smcp.min.js";

export default {
  data() {
    return {
      accountNumber: "",
      password: "",
      confirmPassword: "",
      phone: "",
      smsCode: "",
      inviteCode: "",
      realName: "",
      sex: 1,
      birthday: "",
      wechat: "",
      qq: "",
      email: "",
      address: "",
      captchaCode: "",
      verifyCodeImg: "--",
      captchaKey: "",
      isSelect: true,
      isClickRegister: true,
      sessData: "",
      regFlag: null, //注册设置
      disabled: true,
      type: 3, //行为校验2
      captcha: null, //行为校验
      captchaBox: null,
      captchaText: "",
      captchaMask: false,
      errorCode: false,
      window: window,
      accountMaxLength: "",
      accountP: "",
      smsBtnText: "获取验证码",
      isSmsCode: true,
      Interval: null,
      smData: {
        lang: "",
        mode: "",
        organization: "",
        product: "",
        appId: "",
        channel: "",
      },
    };
  },
  mounted() {
    this.sessData = JSON.parse(sessionStorage.getItem("inviteCode"));
    this.inviteCode = this.sessData || "";
    this.getDefaultStatus();
    this.getRegisterSet();

    //
    if (window.mergeAccount) {
      this.accountMaxLength = 13;
      this.accountP = "必须是4-13位字母和数字组合";
    } else {
      this.accountMaxLength = 15;
      this.accountP = "必须是4-15位字母和数字组合";
    }
  },
  methods: {
    getDefaultStatus() {
      let _this = this;
      this.$http.get(this.$api.getDefaultStatus, false).then((res) => {
        if (res.code == 0) {
          // type   0：默认验证码  1：极验  2：数美"
          _this.type = res.data.type;
          //  _this.type = 2
          if (_this.type === 0) {
            //图片验证码
            //获取验证码图片
            this.captchaData();
          } else if (_this.type === 1) {
            //1：极验
            _this.disabled = false;
            _this.reset();
          } else if (_this.type === 2) {
            //2：数美"
            Object.assign(_this.smData, res.data);
            _this.reset();
          }
        } else {
          this.errorCode = true;
          this.type = null;
          this.moneyModeListReqSuccess = false;
          this.$message.error("加载失败，请重试");
        }
      });
    },
    //行为校验↓
    reset() {
      this.check();
      this.getCaptcha();
    },
    check() {
      if (this.captcha) {
        this.captchaText = "";
      } else {
        this.captchaText = "正在加载...";
      }
    },
    getCaptcha() {
      if (this.type == 1) {
        let _this = this;
        this.$http
          .get(this.$api.geetFirstRegister, "?t=" + window.childCode, false)
          .then((res) => {
            if (res.code == 0) {
              console.log(res, gt);
              window.initGeetest(
                {
                  gt: res.data.gt,
                  challenge: res.data.challenge,
                  new_captcha: res.data.newCaptcha, // 用于宕机时表示是新验证码的宕机
                  offline: res.data.success === 1 ? false : true, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                  product: "float", // 产品形式，包括：float，popup
                  width: "100%",
                  lang: "cn",
                },
                _this.onCaptcha
              );
            } else {
              this.$message.error("获取错误");
            }
          });
      } else if (this.type == 2) {
        let data = {
          ...this.smData,
          width: 300,
          https: location.protocol == "https:",
        };
        initSMCaptcha(data, this.onCaptcha);
      }
    },
    onCaptcha(res) {
      //res是验证实例，可以调用res的示例方法
      var _this = this;
      this.captcha = res;
      console.log(this.captcha, "yyyyyyyyyyyyyyyyyyyyy");
      if (_this.type == 1) {
        res.appendTo("#captcha3");
        res.onReady(_this.check);
      } else if (this.type == 2) {
        this.captchaText = "点击验证";
        this.captcha.onSuccess(function (data) {
          if (data.pass) {
            _this.disabled = false;
            _this.captcha.rid = data.rid;
            _this.captchaText = "验证成功";
            _this.captchaMask = false;
          } else {
            _this.captcha.rid = null;
            _this.captchaText = "验证失败";
          }
        });

        this.captcha.onError(function (errType, errMsg) {
          _this.captcha.rid = null;
          _this.captchaText = "验证失败";
          _this.captchaMask = false;
        });

        this.captcha.onClose(function () {
          _this.captchaMask = false;
        });
      }
    },
    captchaClick() {
      if (this.type == 2) {
        var result = this.captcha.getResult();
        var pass = result.pass;
        if (!pass) {
          this.captcha.verify();
          //行为验证bug:点击关闭按钮，会点击穿透
          //解决：手动再添加一个遮罩层
          this.captchaMask = true;
        }
      }
    },
    async getRegisterSet() {
      var _this = this;
      var key = "member_register";
      let res = await this.$http.get(this.$api.getRegisterSet, key);
      if (res.code == 0) {
        _this.regFlag = res.data.svalue;
        console.log(_this.regFlag, "666666666666666666666666666666");
      }
    },
    captchaData: async function () {
      let _this = this;
      const res = await this.$http.get(_this.$api.captcha);
      if (res.code == 0) {
        _this.verifyCodeImg = res.data.captcha_image_content;
        // _this.captchaCode = res.data.captchaCode;
        _this.captchaKey = res.data.captchaKey;
      } else {
        // this.$message.error(res.msg + "");
      }
    },
    toCDB(str) {
      //全角转为半角
      var tmp = "";
      for (var i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) == 12288) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
        }
        if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
          tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        } else {
          tmp += String.fromCharCode(str.charCodeAt(i));
        }
      }
      return tmp;
    },
    accountBlur() {
      //大写字母强制转化为小写
      this.accountNumber = this.accountNumber.toLowerCase();
      //全角转半角
      this.accountNumber = this.toCDB(this.accountNumber);
      //删除所有空格
      this.accountNumber = this.accountNumber.replace(/\ /g, "");
    },
    passwordBlur() {
      // this.password = this.password.toLowerCase();
      //全角转半角
      this.password = this.toCDB(this.password);
      //删除所有空格
      //this.password = this.password.replace(/\ /g, "");
    },
    confirmPasswordBlur() {
      // this.confirmPassword = this.confirmPassword.toLowerCase();
      //全角转半角
      this.confirmPassword = this.toCDB(this.confirmPassword);
      //this.confirmPassword = this.confirmPassword.replace(/\ /g, "");
    },
    inviteCodeBlur() {
      //全角转半角
      this.inviteCode = this.toCDB(this.inviteCode);
    },
    inviteCodeValid() {
      //邀请码校验
      if (this.inviteCode) {
        return /^[a-zA-Z0-9]*$/.test(this.inviteCode);
      } else {
        return true;
      }
    },
    accountIsValid() {
      //账号校验
      if (window.mergeAccount) {
        return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,13}$/.test(
          this.accountNumber
        );
      } else {
        return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,15}$/.test(
          this.accountNumber
        );
      }
    },
    passwordIsValid() {
      //密码校验
      //return (/(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,15}$/).test(this.password);
      //return /^[a-zA-Z0-9]{6,15}$/.test(this.password);
      return this.password != "" ? true : false;
    },
    passwordIsconfirmPassword() {
      //密码和确认密码是否相同
      return this.password == this.confirmPassword;
    },
    phoneIsValid() {
      //手机格式校验
      if (this.phone) {
        return /^1[3456789]\d{9}$/.test(this.phone);
      } else {
        return true;
      }
    },
    // realNameIsValid() {
    //   //真实姓名校验
    //   if (this.realName) {
    //     return /^.{0,8}$/.test(this.realName);
    //   } else {
    //     return true;
    //   }
    // },
    WeChatIsValid() {
      //微信号校验
      if (this.wechat) {
        return /^[a-zA-Z0-9][a-zA-Z0-9_-]{5,19}$/.test(this.wechat);
      } else {
        return true;
      }
    },
    qqIsValid() {
      //qq校验
      if (this.qq) {
        return /^[1-9][0-9]{4,14}$/.test(this.qq);
      } else {
        return true;
      }
    },
    emailIsValid() {
      // email校验
      if (this.email) {
        return /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/.test(
          this.email
        );
      } else {
        return true;
      }
    },
    registerIsDisabled() {
      //注册按钮是否禁用
      var oldIsDisable = true;
      if (this.type === 0) {
        oldIsDisable =
          this.accountNumber &&
          this.password &&
          this.confirmPassword &&
          this.isSelect &&
          this.captchaCode;
      }
      var requiredFields = [];
      var flag = false;
      if (this.regFlag) {
        for (var k in this.regFlag) {
          flag = true;
          if (this.regFlag[k] == 2) {
            requiredFields.push(k);
          }
        }
      }

      if (flag) {
        var boolean = true;
        for (var i = 0; i < requiredFields.length; i++) {
          if (requiredFields[i] != "sex") {
            boolean *= Boolean(this[requiredFields[i]]);
          }
        }
      }

      var newIsDisable = boolean;
      if (oldIsDisable && newIsDisable) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    getSubmitValue(key) {
      var _this = this;
      console.log(key, this.regFlag[key]);
      if (this.regFlag[key] == 0) {
        //不显示
        return null;
      } else if (_this[key] == "") {
        //选填未填
        return null;
      } else {
        //选填或必填
        if (key == "birthday") {
          return _this.timeSwitch(_this.birthday);
        } else {
          return _this[key];
        }
      }
    },
    timeSwitch(val) {
      if (val) {
        var date = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + "-";
        var M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + "-";
        var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        var time = Y + M + D;
        return time;
      }
    },
    async register() {
      //禁止重复点击
      if (!this.isClickRegister) {
        return;
      }
      this.isClickRegister = false;

      setTimeout(() => {
        this.isClickRegister = true;
      }, 2000);

      let captcha3 = document.querySelector("#captcha3");
      var _this = this;

      //禁用
      if (this.regFlag.inviteCode == 2 && !this.inviteCode.trim()) {
        //必填却没值
        this.$http.showMesasge("邀请码不能为空！");
        return;
      } else if (!_this.accountNumber.trim()) {
        this.$http.showMesasge("账号不能为空！");
        return;
      } else if (!_this.password.trim()) {
        this.$http.showMesasge(
          "密码为6-15位,数字/字母/标点符号3种至少包含2种！"
        );
        return;
      } else if (!_this.confirmPassword.trim()) {
        this.$http.showMesasge("确认密码不能为空！");
        return;
      } else if (this.regFlag.phone == 2 && !this.phone.trim()) {
        this.$http.showMesasge("手机号不能为空！");
        return;
      } else if (
        this.regFlag.smsCode &&
        this.regFlag.phone == 2 &&
        !this.smsCode.trim()
      ) {
        this.$http.showMesasge("短信验证码不能为空！");
        return;
      } else if (this.regFlag.realName == 2 && !this.realName.trim()) {
        this.$http.showMesasge("姓名不能为空！");
        return;
      } else if (this.regFlag.birthday == 2 && !this.birthday.trim()) {
        this.$http.showMesasge("生日不能为空！");
        return;
      } else if (this.regFlag.wechat == 2 && !this.wechat.trim()) {
        this.$http.showMesasge("微信号不能为空！");
        return;
      } else if (this.regFlag.qq == 2 && !this.qq.trim()) {
        this.$http.showMesasge("QQ号不能为空！");
        return;
      } else if (this.regFlag.email == 2 && !this.email.trim()) {
        this.$http.showMesasge("邮箱不能为空！");
        return;
      } else if (this.regFlag.address == 2 && !this.address.trim()) {
        this.$http.showMesasge("地址不能为空！");
        return;
      } else if (this.type == 0 && !this.captchaCode.trim()) {
        this.$http.showMesasge("验证码不能为空！");
        return;
      } else if (!this.isSelect) {
        this.$http.showMesasge("请先勾选开户条约！");
        return;
      }

      if (this.type != 0) {
        var result = this.captcha.getValidate();
        console.log(result);
        if (!result) {
          this.$http.showMesasge("请先通过行为验证");
          return;
        }
      }
      //正则校验
      if (!_this.accountIsValid()) {
        if (window.mergeAccount) {
          this.$http.showMesasge("账号必须为4-13位数字与字母组合");
        } else {
          this.$http.showMesasge("账号必须为4-15位数字与字母组合");
        }
        return;
      } else if (!_this.passwordIsValid()) {
        this.$http.showMesasge("密码为6-15位,数字/字母/标点符号3种至少包含2种");
        //this.$http.showMesasge("密码不能为空");
        return;
      } else if (!_this.passwordIsconfirmPassword()) {
        this.$http.showMesasge("密码与确认密码必须一致");
        return;
      } else if (!_this.phoneIsValid()) {
        this.$http.showMesasge("手机格式不正确");
        return;
      } else if (!_this.inviteCodeValid()) {
        this.$http.showMesasge("邀请码格式不正确");
        return;
      }
      // else if (!this.realNameIsValid()) {
      //   this.$http.showMesasge("姓名不能超过8位！");
      //   return;
      // }
      else if (!this.WeChatIsValid()) {
        this.$http.showMesasge("微信号码不存在！");
        return;
      } else if (!this.qqIsValid()) {
        this.$http.showMesasge("QQ号码不存在！");
        return;
      } else if (!this.emailIsValid()) {
        this.$http.showMesasge("邮箱地址不存在");
        return;
      }

      var params = {
        phone: _this.getSubmitValue("phone"),
        smsCode: _this.getSubmitValue("smsCode"),
        username: _this.accountNumber,
        password: _this.password,
        inviteCode: _this.inviteCode,
        lastLoginVersion: _this.$config.loginVersion,
        realName: _this.getSubmitValue("realName"),
        sex: _this.getSubmitValue("sex"),
        birthday: _this.getSubmitValue("birthday"),
        wechat: _this.getSubmitValue("wechat"),
        qq: _this.getSubmitValue("qq"),
        email: _this.getSubmitValue("email"),
        address: _this.getSubmitValue("address"),
        validateType: this.type,
      };

      //账号处理
      if (window.mergeAccount) {
        params.username = this.accountNumber + window.mergeAccount;
      }
      this.$set(params, "clientItem", window.childCode);
      this.$set(params, "appId", window.theme);
      if (this.type === 1) {
        params.geeTestQueryVO = {
          challenge: result.geetest_challenge,
          seccode: result.geetest_seccode,
          validate: result.geetest_validate,
        };
      } else if (this.type === 2) {
        params.shuMeiQueryVO = {
          rid: result.rid,
        };
      } else if (this.type === 0) {
        params.captchaKey = this.captchaKey;
        params.captchaCode = this.captchaCode;
      }
      console.log(params);
      let res = await _this.$http.post(_this.$api.register, params);
      if (res.code == 0) {
        this.$common.setToken(res.data);
        this.$common.setUser(res.data);

        //注册成功
        this.$message({
          message: "恭喜您，注册成功",
          type: "success",
        });

        sessionStorage.setItem("firstLogin", true);
        // sessionStorage.removeItem("inviteCode");
        console.log(this.$store, _this.$store);
        store.commit("firstLogin", true);

        //获取余额
        this.getUserBalance();
        this.$nkhttp.getUserInfo();
        this.$common.showLogin();
        this.$router.replace({
          path: "/",
        });
      } else {
        this.isClickRegister = true;

        this.$common.clearToken();
        this.$message.error(res.msg);
        if (_this.type === 1) {
          captcha3.innerHTML = "";
        }
        this.getDefaultStatus();
      }
    },
    async getUserBalance() {
      var _this = this;
      let data = {
        clientId: this.$common.getUser().tenant_id, //tenant_id
        clientIp: this.$config.clientIp,
        memberId: this.$common.getUser().user_id, //userid
        username: this.$common.getUser().username,
      };
      var res = await _this.$http.post(_this.$api.getuserMoney, data);
      if (res.code == 0) {
        //余额存本地
        this.$common.setUserBalance(res.data);
      } else {
        console.log("0000------");
      }
    },
    //获取手机验证码
    async getSmsCode() {
      if (!this.isSmsCode) return;
      if (!this.phoneIsValid()) {
        this.$message.error("手机号格式不正确");
        return;
      }
      this.isSmsCode = false;
      const res = await this.$http.get(
        this.$api.sendSmsCode,
        "/" + this.phone + "?functionId=8",
        true
      );

      if (res.code == 0) {
        this.smsCountdown(60);
      } else {
        this.smsBtnText = "重新发送";
        this.$message.error("短信验证码发送失败,请重新获取.");
        this.isSmsCode = true;
      }
    },
    //倒计时
    smsCountdown(timer) {
      this.Interval = setInterval(() => {
        timer--;
        if (timer > 0) {
          this.smsBtnText = timer + "(秒)";
        } else {
          this.smsBtnText = "重新发送";
          (this.isSmsCode = true), clearInterval(this.Interval);
        }
      }, 1000);
    },
  },
  watch: {
    accountNumber() {
      this.registerIsDisabled();
    },
    password() {
      this.registerIsDisabled();
    },
    confirmPassword() {
      this.registerIsDisabled();
    },
    phone() {
      this.registerIsDisabled();
    },
    isSelect() {
      this.registerIsDisabled();
    },
    realName() {
      this.registerIsDisabled();
    },
    sex() {
      this.registerIsDisabled();
    },
    birthday() {
      this.registerIsDisabled();
    },
    wechat() {
      this.registerIsDisabled();
    },
    qq() {
      this.registerIsDisabled();
    },
    email() {
      this.registerIsDisabled();
    },
    address() {
      this.registerIsDisabled();
    },
    captchaCode() {
      this.registerIsDisabled();
    },
  },
};
</script>

